import { gate } from 'hub-http/gates';
export const CHECKOUT_INTERSTITIAL_UI_GATE = gate('SSB:CheckoutInterstitialUI');

// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const RECOMMENDED_VIEW = gate('SSM:RecommendedView');
export const FTS_STAGED_USERS = gate('FTS:StagedUsers');
export const HUBSPOT_CREDITS = gate('HubSpotCredits');
export const REMOVE_MERCH_CARD_STEPPERS_GATE = gate('SSM:RemoveMerchCardSteppers');
export const PURCHASE_MOTION_CTA = gate('SSM:PurchaseMotionCTA');